<template>
  <div>
    <p
      v-if="newExamsList.length < 1"
    >
      Pesquise o exame a ser incluído, selecione-o e clique em confirmar.
    </p>
    <p v-if="newExamsList.length >= 1">
      Exame selecionado. Agora clique em confirmar.
    </p>
    <div class="insert-exam-after-transferred">
      <div
        v-if="newExamsList.length < 1"
        class="form-container"
      >
        <md-input-container class="search">
          <search
            :fetch="searchExam"
            :min-chars="2"
            placeholder="Digite o nome ou código do exame que deseja adicionar.."
            class="search__input-container"
          />
        </md-input-container>
      </div>
      <p
        v-if="newExamsList.length == 0"
        class="search__message"
      >
        Nenhum exame novo adicionado.
      </p>
      <div
        v-else
        class="insert-exam-after-transferred__exams-container"
      >
        <div
          v-for="(item, index) in newExamsList"
          :key="item.componentUniqUid"
          :class="['search-results__exams', 'exam-card-num-' + index]"
        >
          <component
            :is="examComponent[item.type]"
            :index="index"
            :item="item"
            :patient="patient"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import notify from '@/api/notification'
import Search from '@/components/common/Search'
import CommonExam from '@/components/Exams/Create/CommonExam'
import AdditionalExam from '@/components/Exams/Create/AdditionalExam'
import CurveExam from '@/components/Exams/Create/CurveExam'
import PaternityExam from '@/components/Exams/Create/PaternityExam'
import LoadingExam from '@/components/Exams/LoadingExam'

export default {
  name: 'IncludeExamAfterTransferred',
  props: {
    order: Object
  },
  data: () => ({
    examComponent: {
      LOADING: 'loading-exam', // Exame loading
      STANDARD: 'common-exam', // Exame comum
      ADDITIONAL: 'additional-exam', // Exame complementar
      CURVE: 'curve-exam', // Exame de curva
      PATERNITY: 'paternity-exam' // Exame de Paternidade
    }
  }),
  methods: {
    ...mapActions(['includeNewExamAftertransferred']),
    ...mapActions(['clearExamList']),
    ...mapActions(['searchExam'])
  },
  computed: {
    ...mapGetters(['newExamsList']),
    patient () {
      if (this.order) {
        return this.order.patient
      }
      return null
    }
  },
  watch: {
    newExamsList: function (newValue) {
      if (newValue.length > 0) {
        let examTemplate = this.newExamsList[0].type
        if (this.fobiddenExamsTemplates && this.fobiddenExamsTemplates.includes(examTemplate)) {
          this.clearExamList()
          notify({
            title: 'AVISO:',
            message: 'Não é possível adicionar o exame selecionado na amostra.'
          })
        }
      }
    }
  },
  components: {
    search: Search,
    'common-exam': CommonExam,
    'additional-exam': AdditionalExam,
    'curve-exam': CurveExam,
    'paternity-exam': PaternityExam,
    'loading-exam': LoadingExam
  }
}
</script>

<style lang="scss">
.include-exam-after-transferred {
  p {
    padding-bottom: 20px;
  }

  &-content {
    padding-top: 19px;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 32px;
  }

  .dialog-actions {
    width: 100%;
    height: 44px;
    margin-top: 37px;

    .md-button {
      width: 182px;
      height: 33px;
      margin: 6px 7px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }

  .insert-exam-after-transferred {
    #txtNewSampleQuantity {
      pointer-events: none;
      color: #a1a1a1;
      cursor: not-allowed;
    }

    &__exams-container {
      padding: 10px;
      background-color: #f7f7f7;
      border-radius: 8px;
    }

    .exam-curve__container .exam-curve__curves__item {
      width: 8%;
    }

    .md-input-container {
      &.search {
        margin: 0 0 20px;
        padding: 0;
        min-height: 39px;

        &:after {
          display: none;
        }

        .search {
          &__label {
            position: relative;
            display: flex;
            align-items: center;
            float: left;
            width: 105px;
            top: inherit;
            left: inherit;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 1.1px;
            color: #727272;
          }

          &__input-container {
            position: relative;
            display: block;
            width: 100%;
          }
        }
      }
    }

    .search {
      &__message {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 10px 0;
        height: 110px;
        font-size: 15px;
        line-height: 1.5;
        color: #969696;
      }

      &-results__exams {
        margin: 22px 0 20px;

        .multiselect {
          &__content-wrapper {
            max-height: 150px !important;
          }
        }
      }
    }

    .card-form__container {
      transition: min-height 600ms, opacity 600ms;
      opacity: 1;
      min-height: 237px;
      border-radius: 6px;

      .collapsed__list__item__edit-button {
        position: absolute;
        right: 0;
        margin-top: 3px;

        & > .md-icon:not(.md-icon-delete) {
          position: static;
          margin: 0;
          line-height: 16px;
          color: #c2c2c2;
        }
      }

      .card-form__delete-button {
        position: absolute;
        top: 5px;
        right: 0px;
        color: #c2c2c2;
      }

      &.card-form--collapsed {
        transition: min-height 600ms, opacity 600ms;
        min-height: 90px;

        &.exam__container {
          .collapsed__list__item__edit-button {
            position: absolute;
            right: 37px;
            margin-top: 3px;

            & > .md-icon:not(.md-icon-delete) {
              position: static;
              margin: 0;
              line-height: 16px;
              color: #c2c2c2;
            }
          }

          .collapsed__list__item__delete-button {
            position: absolute;
            margin-top: 3px;
            right: 0;

            & > .md-icon {
              top: -4px;
            }
          }
        }

        .submit-button,
        .form-container {
          animation-duration: 700ms;
          animation-name: fadeout;
          display: none;
        }

        .collapsed-container {
          opacity: 1;
          display: flex;
          animation-name: fadein;
          animation-duration: 700ms;

          .collapsed__item {
            .md-input-container {
              flex: 1;
              flex-direction: column;
              margin: 0 15px 0;
              padding-top: 0;

              &:after {
                height: 0;
              }
            }

            h3 {
              font-size: 12px;
              color: #858585;
              font-weight: normal;
              white-space: nowrap;
            }

            p {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 90%;
              color: #303030;
              font-size: 16px;
            }

            input {
              font-size: 16px;
            }
          }
        }
      }

      .form-container {
        animation-name: fadein;
        animation-duration: 700ms;
        display: flex;
        flex-wrap: wrap;

        .exam-item__details-anchor {
          flex-shrink: 1;
        }
        .md-switch-label {
          font-size: 14px;
        }

        .required-fields-label {
          position: absolute;
          right: 5px;
          top: -30px;
          font-size: 12px;
          color: #a80009;
        }

        .tab-label {
          position: absolute;
          right: 180px;
          top: -30px;
          font-size: 12px;
          color: #000;

          strong {
            font-weight: 700;
          }
        }

        .md-layout {
          .md-input-container {
            margin: 0 0 17px;
          }
        }

        .md-input-container,
        .md-input-container.md-input-focused {
          .md-icon {
            color: #c2c2c2;
          }
        }
      }

      .collapsed-container {
        animation-name: fadeout;
        animation-duration: 700ms;
        display: none;
      }
    }

    .IE {
      .insert-exam-after-transferred {
        .search-results__exams {
          .exam__container {
            .exam-item__details.md-flex-25 {
              min-width: 17%;
              max-width: 18.3%;
            }
          }
        }
      }

      @media only screen and (max-width: 1024px) {
        .insert-exam-after-transferred {
          .search-results__exams {
            .paternity-exam {
              .collapsed__item {
                padding: 0;
              }
              .md-flex-35 {
                min-width: 10%;
                .md-theme-default {
                  width: 240px;
                  margin-right: 0;
                }
              }
            }
            .exam__container {
              .exam-item__details.md-flex-25 {
                min-width: 17%;
                max-width: 21.7%;
              }
            }
          }
        }
        .orders-new_container
          .card-form__container.card-form--collapsed
          .collapsed-container
          .collapsed__item
          p {
          width: 100%;
        }
      }
    }
  }
}

// For IE
@media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
  /* IE10+ */
  .insert-exam-after-transferred .search .search-container .search__input {
    height: 200% !important;
  }
}
</style>

